/**
 * Extranet configurable component registrations — aggregator.
 *
 * Called once at module bootstrap (`../routes.tsx`). Each domain owns its
 * own `components/<domain>/register.ts` (so the screen phases run in
 * parallel without touching a shared file): this function only calls them.
 * Every registration is idempotent (`registerOnce`), so HMR and test
 * re-imports never trip the registry's duplicate-id guard.
 *
 * Registered ids follow `extranet.<name>` (inventory: plan `frontend.md`
 * "Component inventory"; `shell` = the sidebar menu, the only configurable
 * part of the chrome); the rules hooks resolve the API client + module
 * from the `IntegratedComponentProvider module="extranet"` mounted by the
 * routes, so their rules are fetched from `/extranet/component-rules`.
 */

import { registerClaimComponents } from './claims/register';
import { registerContractComponents } from './contracts/register';
import { registerFleetComponents } from './fleet/register';
import { registerHomeComponents } from './home/register';
import { registerPiecesComponents } from './pieces/register';
import { registerPremiumComponents } from './premiums/register';
import { registerShellComponents } from './shell/register';

/** Register every extranet configurable component. Idempotent. */
export function registerExtranetComponents(): void {
  registerShellComponents();
  registerHomeComponents();
  registerContractComponents();
  registerClaimComponents();
  registerPremiumComponents();
  registerFleetComponents();
  registerPiecesComponents();
}
